import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Link from '@material-ui/core/Link'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { RenderedFunctionComponent } from 'components/initComponents'
import { RootContainer } from 'components/RootContainer/RootContainer'
import VRLogo from 'images/logos/vr_logo_with_text.svg'
import React from 'react'
import { t } from 'src/helpers'

import BonitaetsmanagerLogo from '../../../../assets/images/bonitaetsmanager_logo.svg'
import { useStyles } from './LogosSection.styles'

export const LogosSection: RenderedFunctionComponent = () => {
  const classes = useStyles()

  // TODO: somehow breakpoints are sets to material-ui
  // default values when trying to use theme ones,
  // further investigation is required
  const isMobileView = useMediaQuery('@media (max-width: 991px)')

  return (
    <RootContainer>
      <Box className={ classes.section }>
        <Container className={ classes.container }>
          <Box display='flex' justifyContent='space-between'>
            {!isMobileView && (
              <Link href='/'>
                <img className={ classes.logo } src={ BonitaetsmanagerLogo } alt={ t('bonitaetsmanager') } />
              </Link>
            )}
            <img className={ classes.logo } src={ VRLogo } alt={ t('banking_group') } />
          </Box>
        </Container>
      </Box>
    </RootContainer>
  )
}

LogosSection.queryString = 'div.logos-section'
